var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path8, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _path9, _path10, _path11, _path12, _polygon, _polygon2, _polygon3, _circle10, _circle11, _circle12, _circle13, _path13, _path14, _rect38, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect39, _circle14, _path41, _path42, _path43, _path44, _g, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _polygon5, _polygon6, _polygon7, _polygon8, _rect40, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _rect41, _rect42, _rect43, _rect44, _rect45, _path82, _path83, _path84, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _rect46, _rect47, _circle27, _circle28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "08eab577-e723-4d12-b868-9f4caa103b0f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1109.79,
    height: 748.34,
    viewBox: "0 0 1109.79 748.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4673c98d-e8c8-4911-bde5-090ef44e1581",
    x1: 600,
    y1: 694.2,
    x2: 600,
    y2: 75.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "gray",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "gray",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "528408a2-f79a-48f6-b2a6-578d2aaf4c5c",
    x1: 597.35,
    y1: 783.63,
    x2: 597.35,
    y2: 223.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "working late") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1151.86,616.41c0,44.37-244.24,207.76-549.27,207.76S57.45,650.05,57.45,605.68s240.11,57.79,545.14,57.79S1151.86,572,1151.86,616.41Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.89,598.7c0,.59,0,1.18,0,1.78-.67,18.44-10.94,36.78-29.68,49.73-19.88,13.72-46.54,20.94-73.91,25.55-4.28.72-8.58,1.37-12.87,2-2.19.3-4.37.6-6.54.88-60.93,8-123.14,9.53-185.06,11-64.77,1.6-129.6,3.18-194.44,4l-12.86.15c-98.38,1.06-196.72.17-294.74-5.41-30.42-1.72-61.14-4-91.3-7.84q-6.45-.79-12.86-1.73c-40-5.73-78.81-14.52-114.17-28.79A254.48,254.48,0,0,1,102,638.72c-22.21-11.79-40.94-26.7-50.21-45A63.12,63.12,0,0,1,45.39,559a81.22,81.22,0,0,1,2.23-12.87,114.68,114.68,0,0,1,12.63-29.71c14.44-24.42,36.13-46.31,54.83-69.24C155,398.31,181,336.56,144.16,286.47c-10.57-14.39-25.85-27-34.46-42.05A67.72,67.72,0,0,1,101.26,218a95.07,95.07,0,0,1-.53-12.87,178.53,178.53,0,0,1,3.75-29.84c6-30.72,17.21-63.84,51.83-83,23.63-13.08,53.75-17.14,84.29-16.37q6.43.15,12.86.6c11.71.77,23.35,2.19,34.59,4,69.44,11.09,133.53,34.26,198.23,55.18,49.26,15.92,100.28,30.81,153.22,37.91,4.28.57,8.56,1.1,12.86,1.56,12.41,1.36,24.93,2.26,37.55,2.63C752.72,179.6,826,166,867.71,130.68,908,96.54,983.56,93.79,1038.4,114.18l.82.31q6.19,2.36,12,5.08c40.41,19,67.48,51.54,71.3,85.59a74.3,74.3,0,0,1,.34,12.74.53.53,0,0,1,0,.13c-2.62,41.89-36.86,77.07-71.63,112.31-4.3,4.35-8.61,8.7-12.87,13.08-11.28,11.58-22.21,23.25-31.69,35.26a165.34,165.34,0,0,0-11.92,17.1A110.45,110.45,0,0,0,986.28,413a71.62,71.62,0,0,0-4.67,19.3,50.47,50.47,0,0,0,5,27.6l.09.2c9.28,18.4,28.92,31.44,51.66,43,4.19,2.14,8.5,4.22,12.87,6.28,24.66,11.64,51.23,22.45,71.43,36.82A107.09,107.09,0,0,1,1137.84,559a77.34,77.34,0,0,1,5.36,6.17,54.14,54.14,0,0,1,11.68,32.69C1154.89,598.16,1154.89,598.43,1154.89,598.7Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.89,598.7c0,.59,0,1.18,0,1.78-.67,18.44-10.94,36.78-29.68,49.73-19.88,13.72-46.54,20.94-73.91,25.55-4.28.72-8.58,1.37-12.87,2-2.19.3-4.37.6-6.54.88-60.93,8-123.14,9.53-185.06,11-64.77,1.6-129.6,3.18-194.44,4l-12.86.15c-98.38,1.06-196.72.17-294.74-5.41-30.42-1.72-61.14-4-91.3-7.84q-6.45-.79-12.86-1.73c-40-5.73-78.81-14.52-114.17-28.79A254.48,254.48,0,0,1,102,638.72c-22.21-11.79-40.94-26.7-50.21-45A63.12,63.12,0,0,1,45.39,559a81.22,81.22,0,0,1,2.23-12.87,114.68,114.68,0,0,1,12.63-29.71c14.44-24.42,36.13-46.31,54.83-69.24C155,398.31,181,336.56,144.16,286.47c-10.57-14.39-25.85-27-34.46-42.05A67.72,67.72,0,0,1,101.26,218a95.07,95.07,0,0,1-.53-12.87,178.53,178.53,0,0,1,3.75-29.84c6-30.72,17.21-63.84,51.83-83,23.63-13.08,53.75-17.14,84.29-16.37q6.43.15,12.86.6c11.71.77,23.35,2.19,34.59,4,69.44,11.09,133.53,34.26,198.23,55.18,49.26,15.92,100.28,30.81,153.22,37.91,4.28.57,8.56,1.1,12.86,1.56,12.41,1.36,24.93,2.26,37.55,2.63C752.72,179.6,826,166,867.71,130.68,908,96.54,983.56,93.79,1038.4,114.18l.82.31q6.19,2.36,12,5.08c40.41,19,67.48,51.54,71.3,85.59a74.3,74.3,0,0,1,.34,12.74.53.53,0,0,1,0,.13c-2.62,41.89-36.86,77.07-71.63,112.31-4.3,4.35-8.61,8.7-12.87,13.08-11.28,11.58-22.21,23.25-31.69,35.26a165.34,165.34,0,0,0-11.92,17.1A110.45,110.45,0,0,0,986.28,413a71.62,71.62,0,0,0-4.67,19.3,50.47,50.47,0,0,0,5,27.6l.09.2c9.28,18.4,28.92,31.44,51.66,43,4.19,2.14,8.5,4.22,12.87,6.28,24.66,11.64,51.23,22.45,71.43,36.82A107.09,107.09,0,0,1,1137.84,559a77.34,77.34,0,0,1,5.36,6.17,54.14,54.14,0,0,1,11.68,32.69C1154.89,598.16,1154.89,598.43,1154.89,598.7Z",
    transform: "translate(-45.11 -75.83)",
    fill: "url(#4673c98d-e8c8-4911-bde5-090ef44e1581)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.27,119.57V330.33c-4.3,4.36-8.61,8.71-12.87,13.09V114.18Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.91,217.9a.57.57,0,0,1,0,.13H101.26a95.21,95.21,0,0,1-.53-12.87H1122.57A74.27,74.27,0,0,1,1122.91,217.9Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 241.32,
    cy: 71.81,
    r: 3.75,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.22,
    cy: 64.3,
    r: 3.75,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.68,
    cy: 71.81,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.04,
    cy: 68.06,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.44,
    cy: 180.51,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 904.01,
    cy: 95.53,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.74,
    cy: 97.01,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 824.66,
    cy: 93.79,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1027.33,
    cy: 98.62,
    r: 1.61,
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.89,598.7c0,.59,0,1.18,0,1.78-.51,18.58-10.8,37.11-29.68,50.15-19.88,13.72-46.54,20.94-73.91,25.55-4.28.72-8.58,1.37-12.87,2-2.19.3-4.37.6-6.54.88-15,2-30.08,3.53-45.21,4.81-20.3,1.72-40.7,2.91-61.12,3.79-26.22,1.15-52.49,1.8-78.73,2.45-51.29,1.26-102.62,2.52-154,3.39l-18.23.3-22.24.3-12.86.15c-81,.86-161.88.42-242.62-2.88q-8.06-.32-16.09-.7-18-.79-36-1.83c-24.05-1.36-48.29-3.08-72.27-5.63q-9.54-1-19-2.21-6.45-.79-12.86-1.73-7.14-1-14.22-2.18c-35-5.72-68.79-14-99.95-26.62A259.37,259.37,0,0,1,102,639.14v-176c4.44-5.15,8.85-10.3,13.09-15.51,5.1-6.26,10-12.71,14.5-19.33h96.8V368.65h170.5V499.79H674.6v-104H995a112,112,0,0,0-8.39,16.65V413h-.37a71.62,71.62,0,0,0-4.67,19.3,50.47,50.47,0,0,0,5,27.6v.42l.09.2c9.28,18.4,28.92,31.44,51.66,43,4.19,2.14,8.5,4.22,12.87,6.28,24.41,11.52,50.71,22.24,70.83,36.4l.6.42A107.61,107.61,0,0,1,1137.43,559c.15.14.28.28.41.42a77.34,77.34,0,0,1,5.36,6.17,54.21,54.21,0,0,1,11.68,32.27C1154.89,598.16,1154.89,598.43,1154.89,598.7Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.89,598.7c0,.59,0,1.18,0,1.78-.51,18.58-10.8,37.11-29.68,50.15-19.88,13.72-46.54,20.94-73.91,25.55-4.28.72-8.58,1.37-12.87,2-2.19.3-4.37.6-6.54.88-15,2-30.08,3.53-45.21,4.81-20.3,1.72-40.7,2.91-61.12,3.79-26.22,1.15-52.49,1.8-78.73,2.45-51.29,1.26-102.62,2.52-154,3.39l-18.23.3-22.24.3-12.86.15c-81,.86-161.88.42-242.62-2.88q-8.06-.32-16.09-.7-18-.79-36-1.83c-24.05-1.36-48.29-3.08-72.27-5.63q-9.54-1-19-2.21-6.45-.79-12.86-1.73-7.14-1-14.22-2.18c-35-5.72-68.79-14-99.95-26.62A259.37,259.37,0,0,1,102,639.14v-176c4.44-5.15,8.85-10.3,13.09-15.51,5.1-6.26,10-12.71,14.5-19.33h96.8V368.65h170.5V499.79H674.6v-104H995a112,112,0,0,0-8.39,16.65V413h-.37a71.62,71.62,0,0,0-4.67,19.3,50.47,50.47,0,0,0,5,27.6v.42l.09.2c9.28,18.4,28.92,31.44,51.66,43,4.19,2.14,8.5,4.22,12.87,6.28,24.41,11.52,50.71,22.24,70.83,36.4l.6.42A107.61,107.61,0,0,1,1137.43,559c.15.14.28.28.41.42a77.34,77.34,0,0,1,5.36,6.17,54.21,54.21,0,0,1,11.68,32.27C1154.89,598.16,1154.89,598.43,1154.89,598.7Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.69,
    y: 376.79,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134.45,
    y: 376.79,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 659.88,
    y: 337.12,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 737.09,
    y: 337.12,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 820.01,
    y: 337.12,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 659.88,
    y: 396.1,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 737.09,
    y: 396.1,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 820.01,
    y: 396.1,
    width: 28.6,
    height: 19.3,
    fill: "#bbb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 659.88,
    y: 455.07,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 737.09,
    y: 455.07,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 820.01,
    y: 455.07,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 659.88,
    y: 514.05,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 737.09,
    y: 514.05,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 820.01,
    y: 514.05,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 659.88,
    y: 573.03,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 737.09,
    y: 573.03,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 820.01,
    y: 573.03,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M986.28,413a71.62,71.62,0,0,0-4.67,19.3H965.92V413Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 920.81,
    y: 396.1,
    width: 28.6,
    height: 19.3,
    fill: "#bbb"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 920.81,
    y: 455.07,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 920.81,
    y: 514.05,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 920.81,
    y: 573.03,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 314.6,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 357.87,
    width: 28.6,
    height: 19.3,
    fill: "#bbb"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 401.13,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 444.4,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 487.66,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 530.93,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 574.19,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 88.69,
    y: 427.23,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 134.45,
    y: 427.23,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 88.69,
    y: 477.67,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 134.45,
    y: 477.67,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 88.69,
    y: 528.11,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 134.45,
    y: 528.11,
    width: 28.6,
    height: 19.3,
    opacity: 0.4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 408.96,
    y: 446.45,
    width: 142.98,
    height: 17.25,
    opacity: 0.4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 408.96,
    y: 501.49,
    width: 142.98,
    height: 17.25,
    opacity: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 408.96,
    y: 556.54,
    width: 142.98,
    height: 17.25,
    opacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.46,76.52v604q-6.45-.79-12.86-1.73V75.92C244.89,76,249.17,76.22,253.46,76.52Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M652.36,175.15V693.66l-12.86.15V173.58Q645.92,174.45,652.36,175.15Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.84,559H45.39a81.22,81.22,0,0,1,2.23-12.87H1122.7A105.88,105.88,0,0,1,1137.84,559Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.4,503.06c4.19,2.14,8.5,4.22,12.87,6.28V675.76c-4.28.72-8.58,1.37-12.87,2Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "337.33 229.81 334.87 229.81 334.87 227.35 334.43 227.35 334.43 229.81 331.97 229.81 331.97 230.25 334.43 230.25 334.43 232.71 334.87 232.71 334.87 230.25 337.33 230.25 337.33 229.81",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "848.61 178.68 846.15 178.68 846.15 176.22 845.7 176.22 845.7 178.68 843.25 178.68 843.25 179.12 845.7 179.12 845.7 181.58 846.15 181.58 846.15 179.12 848.61 179.12 848.61 178.68",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.6 168.73 393.14 168.73 393.14 166.27 392.69 166.27 392.69 168.73 390.24 168.73 390.24 169.18 392.69 169.18 392.69 171.63 393.14 171.63 393.14 169.18 395.6 169.18 395.6 168.73",
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.85,
    cy: 325.96,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.02,
    cy: 182.12,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.81,
    cy: 258.37,
    r: 1.61,
    fill: "#e6e6e6"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.43,
    cy: 272.18,
    r: 1.61,
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M760.43,619s-34.31,8.3-47.89,23.83c-4.55,5.19-11.3,8.93-18.27,11.6V631c7.85-13.18,15.76-27.84,15.76-27.84.36-.72,3.22-10.83,3.22-10.83,6.44-5.06-.36-22.74-.36-22.74s3.94-11.19,1.79-13.36-.36-7.94,1.43-10.47,1.43-5.78,1.43-7.94-2.86-5.42-7.51-7.22.36-4.69,3.22-5.42,3.58-7.58.36-11.19.36-5.77,2.14-9.74S710,501,710,501V464.5h0s-2.15-11.91-4.29-32.85-10.37-23.1-10.37-23.1a94.19,94.19,0,0,1-12.87-5.06,88.15,88.15,0,0,0-13.58-5.05s-9.65,0-17.52-2.42-11.95-2.59-11.95-2.59l-1.29-.64a46.83,46.83,0,0,1-21.69-23c-.22-.5-.42-1-.62-1.48a50.48,50.48,0,0,0,5.71-7.58l0-.06c0,.37,0,.74,0,1.11,0,.15,0,.31,0,.46,0,.89,0,1.78,0,2.67h0V365c5.7-10.07,22.24-12.37,23.81-23.87a12,12,0,0,0,.11-1.58v-.07c0-.38,0-.77,0-1.16-.21-3.21-1.31-6.41-1.52-9.65a18.53,18.53,0,0,1,0-2.79v.06c.74-8.93,7.47-16.7,10.55-25.37a30.41,30.41,0,0,0,1.61-7.22v-.07c.08-.74.13-1.49.15-2.24,0-.18,0-.37,0-.55,0-.52,0-1,0-1.56a33.78,33.78,0,0,0-11.15-24.4c-5.7-4.95-13.23-8.06-17.18-14.53-1.84-3-2.74-6.56-4.75-9.46-3.78-5.48-10.72-7.71-17.29-8.5s-13.32-.53-19.6-2.59c-4.46-1.46-8.5-4.05-13-5.35a24.87,24.87,0,0,0-26.71,9.63c-2.37,3.46-3.92,7.6-7.12,10.3-6.55,5.54-17.66,3.14-23.4,9.52-3.15,3.51-3.51,8.29-3.13,13.17,0,.06,0,.12,0,.18,0,.37.07.75.11,1.13,0,.18,0,.36,0,.53s0,.38.07.57c.2,1.75.45,3.49.67,5.17,0,.26.06.51.09.77l.18,1.57c0,.38.06.76.1,1.14s.07,1,.1,1.42,0,.74.07,1.12a77.16,77.16,0,0,1-8.2,38.5c-5.41,10.61-13.45,20.39-14.85,32.24a34.73,34.73,0,0,0-.16,5.85c0,.23,0,.46,0,.69s.06.7.09,1.05.08.81.13,1.21c0,.23.06.46.09.69.07.53.15,1.06.24,1.6l.06.34c1.42,8.08,4.64,16,6.35,24.16a65.34,65.34,0,0,1,1.28,9.13.13.13,0,0,0,0,.06c.06,1,.11,1.95.14,2.93,0,1.32,0,2.65,0,4a63.46,63.46,0,0,1-8.33,2.56c-5,.72-19.67,13.72-18.6,17s-6.56,26-6.77,26.69h0l-12,83s-6.37,6.14-4.38,10.11-.39,10.83-.39,10.83-10.76,4.69-8.37,7.58,1.3,8.3-.34,11.91-4.33,10.11,0,11.19.74,15.17.74,15.17,15.09-1.74,14,7.22c-.36,2.85,10.55,10.69,15.1,13.83V663c-6.11-1.71-13.29-3.93-17.87-6.07-9.29-4.33-61.48-12.63-72.92,12.28s15.73,58.12,22.52,61.73c0,0,6.44,5.05,7.87,7.58s9.65,3.25,9.65,3.25,8.58,4,10.72,6.13c1.58,1.6,14.65,5.75,30.14,9h0s-12.51,28.8,7.9,26.43,30.35-12.42,44.74-12.42c5.75,0,16.43-.81,27.18-1.77a72.24,72.24,0,0,1,8,1.89,102.81,102.81,0,0,0,18.58,4s16.09,8.66,24.67,6.49a5.45,5.45,0,0,0,1.94-1l.2,0c1.56-.39,3.33-2,5.17-4.43,10.73,1.1,23,2.66,27.56,4.44,8.89,3.43,72.48-1.32,72.48-1.32s41.08.81,52.85,4.37,7.59-36.35-14.13-40.84A89.12,89.12,0,0,0,719.77,741a39.5,39.5,0,0,0,4.11-5c7.82-.71,13-1.15,13-1.15s20.73-10.11,32.53-16.25a74.22,74.22,0,0,0,20-15.88s10.36-6.5,14.65-9,6.43-10.83,6.43-10.83C843,609.24,760.43,619,760.43,619Zm-93.08-92.38c0-1.21,0-2.43,0-3.64C668.51,523.8,668.34,525.09,667.35,526.61Zm.34,25.53c.87,1.14,1.71,2.18,2.31,3,2.31,3-1.87,4.4-1.57,9.37.07,1.11.17,2.66.27,4.38h0C668.26,561.73,667.9,555.83,667.69,552.14Z",
    transform: "translate(-45.11 -75.83)",
    fill: "url(#528408a2-f79a-48f6-b2a6-578d2aaf4c5c)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M481.63,666.07s-20-4.65-29.31-8.94-61.48-12.51-72.92,12.16,15.73,57.54,22.52,61.12S474.84,685,474.84,685L527,707l10-34.14Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#666"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 458.59,
    y: 597.03,
    width: 227.07,
    height: 78.99,
    rx: 36.83,
    ry: 36.83,
    fill: "#666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M730.77,712.35a39.41,39.41,0,0,1-6.58,21.84,40,40,0,0,1-5,6.1,39.37,39.37,0,0,1-27.93,11.57H543.2a39.5,39.5,0,0,1,0-79H691.27a39.5,39.5,0,0,1,39.5,39.49Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M607.14,714.66s-22.77,5.85-41.35,5.59S460.3,756.1,460.3,756.1s-12.51,28.52,7.9,26.16S498.55,770,512.94,770s59.66-5,59.66-5l43.56-32.18Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M621.39,445.53l-40.84,8.05-2.65.53s-32.29-8.58-33.36-9.3-30.38-40.21-30.38-40.21,14.82.16,26.46-6.55c.42-.24.83-.5,1.24-.75a25.8,25.8,0,0,0,11-13.49c.21-.59.39-1.2.56-1.84,1.24-4.78,1.32-10.57-.34-17.58-4-16.67,5.2-21.26,17.39-20.86,17.61.58,41.58,11.57,41.58,11.57a48.87,48.87,0,0,0,3.77,16.3c.19.48.4,1,.62,1.46a46.54,46.54,0,0,0,21.69,22.75l1.29.64c1.3.62,2.67,1.21,4.09,1.74C674.65,409.79,621.39,445.53,621.39,445.53Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M616.48,372.86a51.51,51.51,0,0,1-63.58,10.95c1.76-5.12,2.09-11.49.22-19.42-9.65-40.75,59-9.29,59-9.29A49.53,49.53,0,0,0,616.48,372.86Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M629.37,336.66a51.12,51.12,0,0,1-7.8,27.23,50.39,50.39,0,0,1-5.71,7.51A51.18,51.18,0,0,1,581,388c-1,.07-2.07.1-3.11.1a51.47,51.47,0,1,1,51.47-51.47Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M621.39,445.53l-40.84,8.05-2.65.53s-32.29-8.58-33.36-9.3-30.38-40.21-30.38-40.21,14.82.16,26.46-6.55c.42-.24.83-.5,1.24-.75,3.7,4,15.81,15.31,34.84,15.23A50.33,50.33,0,0,0,584,412c5.74-.88,11.53-1.45,17.31-2,11.07-1.16,28-4.52,36.89-14.3l1.29.64c1.3.62,2.67,1.21,4.09,1.74C674.65,409.79,621.39,445.53,621.39,445.53Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M667.5,549.9c.35,7.87,6.08,96.51,6.08,96.51H495.21l1.21-55.81,1-44.64.32-14.65,1.43-50.75L494,476,465.9,451.24h0c.21-.66,7.83-23.25,6.77-26.43s13.59-16.08,18.6-16.8a65.12,65.12,0,0,0,8.38-2.55c8.43-3,19.68-7.32,20.92-6.64,1.75.94,19.29-.69,20-.76h0s12.94,16.73,36.06,16.63a49,49,0,0,0,7.27-.58c5.74-.88,11.53-1.45,17.31-2.05,11.63-1.21,29.71-4.86,38.18-15.8,0,0,4.09.17,11.95,2.56s17.52,2.4,17.52,2.4a88.91,88.91,0,0,1,13.58,5,95,95,0,0,0,12.87,5s8.22,2.14,10.37,22.87S710,466.62,710,466.62L667.5,503.43S667.15,542,667.5,549.9Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.8 535.91 427.05 545.92 450.46 554.17 466.55 524.83 451.72 514.82 427.95 505.53 414.37 513.39 420.8 535.91",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M665.71,661.06s33.24-2.5,46.83-17.87,47.89-23.59,47.89-23.59,82.57-9.65,50,63.27c0,0-2.14,8.22-6.43,10.72s-14.65,8.94-14.65,8.94L662.52,691.45Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M730.77,712.35a39.41,39.41,0,0,1-6.58,21.84c-21.34,1.89-68.6,6.33-78.49,9.09-12.15,3.37-36.74-2.5-39.43-3.16l-.25-.06s-4.74-14.38-7-23.58c-1-4.18-1.53-7.29-.87-7.52,2.15-.71,21.81-6.08,21.45-3s59-23.06,59-23.06l1.82,22.88C686.45,712.68,730.77,702.42,730.77,712.35Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M791.89,693.23l-2.5,9.3a74.09,74.09,0,0,1-20,15.72c-11.8,6.08-32.53,16.09-32.53,16.09s-76.13,6.43-89,10-39.68-3.22-39.68-3.22-10-30.38-7.86-31.1,21.8-6.07,21.45-3,59-23.06,59-23.06Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M579.92,773.37s37.42,2.61,46.32,6,72.48-1.3,72.48-1.3,41.08.8,52.85,4.32,7.59-36-14.13-40.43-52.33,2.09-52.33,2.09-34.54-4.45-38.73-5-31.78.25-31.78.25Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M432.87,674.72s49.46,4.45,63.06,12.56Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M741.37,642.28s-38.73,9.42-53.91,23.28Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M435.75,663.47c.79.26,22.77,3.14,22.24,5.23S435.75,663.47,435.75,663.47Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M401.21,718.61l2.86,10.73s6.43,5,7.86,7.5,9.65,3.22,9.65,3.22,8.58,3.93,10.73,6.07,25.37,8.94,47.18,11.8,62.19,8.22,70.77,11.08a103,103,0,0,0,18.59,3.93s16.08,8.58,24.66,6.44,23.23-41.11,23.23-41.11-56.47-13.22-58.26-17.51-56.12-24.3-56.12-24.3l-32.17.76Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M399.06,719.68l2.86,10.73s6.44,5,7.87,7.5,9.65,3.22,9.65,3.22,8.58,3.93,10.72,6.08,25.38,8.93,47.18,11.79,62.2,8.22,70.78,11.08A103.32,103.32,0,0,0,566.7,774s16.09,8.57,24.67,6.43,23.23-41.11,23.23-41.11-56.48-13.22-58.26-17.51S474.84,685,474.84,685l-25-5.72Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#666"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M472.15,447.67l-6.25,3.58-12,82.21s-6.37,6.08-4.38,10-.39,10.72-.39,10.72-10.76,4.65-8.37,7.51,1.3,8.22-.34,11.79-4.33,10,0,11.08.74,15,.74,15,15.09-1.72,14,7.14c-.45,3.58,17.06,15,17.06,15s-19.9-36.1,24.68-31.1l3.83-20.35s3.83-11.46,0-15,.86-20.55.86-20.55l.84-73.81Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.44,553.84c.79,1.31,24.86,4,26.43,8.27S462.44,553.84,462.44,553.84Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M454.85,574.25s3.27-10.21,11-8.38S454.85,574.25,454.85,574.25Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M450.67,589.16s5.75-13.61,13.6-12.56S450.67,589.16,450.67,589.16Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M712.54,588.86l-2.51,15s-25.73,47.19-30.38,47.9-30-31.45-30-31.45l-6.79-31.46,26.73-5.07,11.87-11.73S711.46,574.92,712.54,588.86Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M700.38,459.83l9.65,6.79v36.1s7.51-.72,5.72,3.22-5.36,6.07-2.14,9.65,2.5,10.36-.36,11.08-7.86,3.57-3.22,5.36,7.51,5,7.51,7.15.36,5.36-1.43,7.86-3.57,8.22-1.43,10.37-1.79,13.22-1.79,13.22,6.8,17.52.36,22.52c0,0-2.86,10-3.22,10.72,0,0,4.51-34.79-40.46-20.08,0,0-.83-13.26-1.14-18.17s3.88-6.35,1.57-9.28-8.09-9.66-5.36-11.44,1.79-5,.71-7.51-4.85-2.5-1.43-5.54,5.45-5.89,3.44-7.32-5.5-6.09-2.72-8.23,2.86-33.24,2.86-33.24S678.94,437.31,700.38,459.83Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M695.84,521.33s13.74-3.73,14.19,0S695.84,521.33,695.84,521.33Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M680.4,531.6s18.84-4.71,21.19-1.05S680.4,531.6,680.4,531.6Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M676.21,541.54s28.26-3.93,30.09,1.83S676.21,541.54,676.21,541.54Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M680.4,553.84c1.05.26,27.21,2.09,27.73,7.06S680.4,553.84,680.4,553.84Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 425.09,
    y: 494.12,
    width: 224.08,
    height: 127.27,
    rx: 10.47,
    ry: 10.47,
    fill: "#333"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.13,
    cy: 557.76,
    r: 8.26,
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M507.72,491.94s21.48,16.42,38.09,3.91C545.81,495.85,517.73,498.4,507.72,491.94Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M616.48,496.36s21.47,16.41,38.08,3.9C654.56,500.26,626.49,502.82,616.48,496.36Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M629.37,336.66a51.12,51.12,0,0,1-7.8,27.23c-.43-14.33-3.8-28.67-11.6-40.64-7.14-11-28.85-30.19-43.77-24.84a10.57,10.57,0,0,0-6.52,7c-1.48,5.62,2.85,8,5.63,12.43a38.11,38.11,0,0,1,5.2,25.68,35.72,35.72,0,0,1-.75,3.56c-2.35,8.82-7.73,18.91-2.18,26.14,3.87,5,12.19,6.78,13.32,13A7.59,7.59,0,0,1,581,388c-.26,4.21-3.85,7.92-5.42,12.05-1.84,4.87-.8,9.71,1.11,14.6,2.48,6.38,6.44,12.83,7.4,19.57s-1.11,13-3.55,19.33c-2.31,6-5,11.95-5.9,18.2-1.73,11.88,2.63,25.62-4.85,35a5.24,5.24,0,0,1-3.27,2.21c-4.79.5-4-8.11-7.83-11,.41,5,.8,10.22-1,14.9s-6.54,8.66-11.5,7.87l-1.71-11.23a32.43,32.43,0,0,1-11.9,7.45A86.74,86.74,0,0,1,545,483.35c-12.59,6.06-19.93,19.18-26.48,31.52-4.08,7.71-8.31,16.13-6.88,24.74.58,3.51,2.09,6.85,2.42,10.38s-.95,7.66-4.24,9c-2.87,1.17-6.22-.23-8.29-2.57l-.36-.43c-.2-.26-.39-.53-.57-.8a13.43,13.43,0,0,1-.95-1.7,32.89,32.89,0,0,1-2-6.57l-.22-1c-3.33-14.61-6.33-29.68-3.89-44.46.9-5.44,2.54-10.84,2.34-16.36A30,30,0,0,0,494,476c-2.92-8.18-8.54-15.69-11.74-23.93a.71.71,0,0,1-.08-.18c-1.68-4.36-2.51-9.81.6-13.31,1.6-1.81,4-2.72,6-4,6.22-4.05,9-11.74,10.15-19.08a64.88,64.88,0,0,0,.78-10c8.43-3,19.68-7.32,20.92-6.64,1.75.94,19.29-.69,20-.76,5.34-3.08,10-7.61,12.28-14.24.21-.59.39-1.2.56-1.84a51.47,51.47,0,1,1,75.91-45.31Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M569.76,344.94c-2.36,8.82-7.73,18.91-2.17,26.15,3.87,5,12.19,6.77,13.3,13,.89,5-3.52,9.12-5.3,13.82-4.24,11.23,6.82,22.27,8.5,34.16,1.83,12.9-7.57,24.65-9.44,37.54-1.73,11.88,2.63,25.61-4.85,35a5.18,5.18,0,0,1-3.27,2.21c-4.79.51-4-8.1-7.83-11,.41,5,.8,10.22-1,14.9s-6.54,8.65-11.5,7.87l-1.71-11.24a32.39,32.39,0,0,1-11.9,7.45A86.8,86.8,0,0,1,545,481.21c-12.59,6.06-19.92,19.18-26.47,31.51-4.09,7.71-8.31,16.14-6.89,24.75.58,3.51,2.09,6.84,2.42,10.38s-.95,7.65-4.24,9c-3,1.25-6.63-.41-8.65-3s-2.8-5.89-3.53-9.08c-3.42-14.92-6.61-30.32-4.12-45.42.9-5.45,2.54-10.85,2.34-16.36-.43-12.07-9.34-22-13.68-33.23-1.69-4.37-2.51-9.81.6-13.31,1.6-1.81,4-2.72,6-4,6.21-4.06,9-11.74,10.14-19.08a66.12,66.12,0,0,0-.67-23.88c-2.51-11.75-8.27-23.23-6.84-35.16,1.4-11.74,9.44-21.42,14.85-31.93a75.54,75.54,0,0,0,7.66-44.15c-.93-7.05-2.56-15.21,2.22-20.48,5.74-6.32,16.85-3.94,23.4-9.42,3.2-2.67,4.75-6.78,7.12-10.2a25,25,0,0,1,26.71-9.54c4.5,1.29,8.54,3.85,13,5.3,6.28,2,13,1.78,19.6,2.57s13.51,3,17.29,8.41c2,2.88,2.91,6.39,4.75,9.37,3.95,6.4,11.48,9.48,17.18,14.39a33.34,33.34,0,0,1,9.38,35.61c-3.4,9.47-11.27,17.85-10.6,27.89.27,4.13,2,8.18,1.46,12.27-1.58,11.39-18.11,13.66-23.82,23.64.46-16.36-2.68-33.21-11.61-46.92-7.14-11-28.85-30.2-43.77-24.85a10.61,10.61,0,0,0-6.52,7c-1.48,5.61,2.85,8,5.63,12.43A37.8,37.8,0,0,1,569.76,344.94Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.65,401.62a65.55,65.55,0,0,0-1.43-15.3c-2.13-10-6.59-19.79-7-29.83-.58,11.18,4.65,22,7,33A65.65,65.65,0,0,1,499.65,401.62Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.25,482.77c.87-1.59,1.77-3.17,2.74-4.71-12.58,6.06-19.92,19.18-26.47,31.52-3.79,7.13-7.68,14.89-7.1,22.83.48-6.81,3.83-13.45,7.1-19.62C524.58,501.38,531.32,489.32,542.25,482.77Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514,547.44c-.38,2.7-1.72,5.26-4.18,6.27-3,1.24-6.63-.41-8.64-3s-2.81-5.88-3.54-9.08c-2.44-10.66-4.76-21.58-5-32.45-.24,11.93,2.3,23.95,5,35.67.73,3.19,1.52,6.5,3.54,9.08s5.61,4.24,8.64,3c3.29-1.35,4.58-5.46,4.25-9C514,547.76,514,547.6,514,547.44Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.92,334.2a36.29,36.29,0,0,1-1.16,7.6c-1.74,6.53-5.14,13.77-4.53,20,.48-5.44,3.08-11.36,4.53-16.81A36.14,36.14,0,0,0,570.92,334.2Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.51,286.48a75.05,75.05,0,0,0-.62-11.41c-.37-2.78-.84-5.74-1-8.63-.23,3.85.47,8,1,11.85A74.85,74.85,0,0,1,514.51,286.48Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.9,384.19c0-.09,0-.16-.07-.25-.76,3.72-3.82,7.12-5.23,10.86a15.23,15.23,0,0,0-.88,7,14.38,14.38,0,0,1,.88-3.78C577.37,393.31,581.78,389.15,580.9,384.19Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.86,479.85c-.44-12.07-9.34-22-13.69-33.23a22.78,22.78,0,0,1-1.4-5.5,18.58,18.58,0,0,0,1.4,8.72c4.28,11.08,12.94,20.83,13.64,32.63C495.86,481.6,495.89,480.72,495.86,479.85Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,318c-7.15-11-28.85-30.2-43.77-24.85a10.62,10.62,0,0,0-6.53,7,7.57,7.57,0,0,0-.11,3.76c0-.18.06-.36.11-.54a10.6,10.6,0,0,1,6.53-7c14.92-5.35,36.62,13.88,43.77,24.85,8.08,12.42,11.41,27.41,11.63,42.28C621.84,347.55,618.65,331.28,610,318Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.4,341.25c-1.57,11.36-18,13.65-23.77,23.57,0,1.09,0,2.19,0,3.28,5.7-10,22.24-12.25,23.81-23.64a13.57,13.57,0,0,0,0-3.37A.86.86,0,0,1,645.4,341.25Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.54,301.08c-3.4,9.48-11.27,17.85-10.6,27.9,0,.14,0,.29,0,.44.74-8.85,7.47-16.53,10.55-25.12a31.48,31.48,0,0,0,1.75-12.24A30.57,30.57,0,0,1,654.54,301.08Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.8,501.49a5.2,5.2,0,0,1-3.27,2.22c-4.79.51-4-8.1-7.83-11,.1,1.14.19,2.29.25,3.44,3.56,3.08,2.9,11.27,7.58,10.77a5.15,5.15,0,0,0,3.27-2.21c4.27-5.36,4.68-12.13,4.57-19.16C574.26,491.41,573.41,497,569.8,501.49Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.69,507.61c-1.82,4.69-6.54,8.66-11.51,7.87q-.85-5.61-1.7-11.24a32.62,32.62,0,0,1-11.31,7.23c-.22,1.14-.43,2.29-.6,3.44a32.42,32.42,0,0,0,11.91-7.45q.85,5.63,1.7,11.24c5,.78,9.69-3.18,11.51-7.87A25.62,25.62,0,0,0,559,500.66,21.63,21.63,0,0,1,557.69,507.61Z",
    transform: "translate(-45.11 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.65,466.49a57.13,57.13,0,0,0-.43,9.11,45.61,45.61,0,0,1,.43-5.89c1.79-12.29,10.4-23.54,9.62-35.73C583.58,445,576.28,455.29,574.65,466.49Z",
    transform: "translate(-45.11 -75.83)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M872,637s-6.79,31.63,23.43,35.38l1.87-3.51S873.9,646.87,872,637Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M906.94,668.66l-7,1.49-.7.15s-18.75-15.22-18.51-49.2a85,85,0,0,0,8.95,14.17C897.09,645.1,905.54,658.23,906.94,668.66Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M909.32,671.92a4.43,4.43,0,0,1-3.78.49c-18-4.22-11.95-63-11.95-63,1,.47,2.09,8,6.24,17.6C907.11,644,915.11,667.66,909.32,671.92Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M949.34,637s1.17,31.63-29.05,35.38l-1.87-3.51S947.47,646.87,949.34,637Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M940.68,621.1c.22,34-24.14,49.2-24.14,49.2l-.7-.15-7-1.49c1.39-10.43,9.86-23.56,17.28-33.39A76,76,0,0,1,940.68,621.1Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M915.73,668.84a11.18,11.18,0,0,1-4,3.08h0a7.69,7.69,0,0,1-1.47.49c-4.44,1-6-2.16-5.74-7.6.42-9.69,6.51-26.49,12-39,3.94-9.06,10.37-15.92,11.33-16.37C927.79,609.39,927.52,655.18,915.73,668.84Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M910.69,588.77s-20.15,71.46-2.81,82.24S915.14,595.1,910.69,588.77Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M872,637s-6.79,31.63,23.43,35.38l1.87-3.51S873.9,646.87,872,637Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M906.94,668.66l-7,1.49-.7.15s-18.75-15.22-18.51-49.2a85,85,0,0,0,8.95,14.17C897.09,645.1,905.54,658.23,906.94,668.66Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M909.32,671.92a4.43,4.43,0,0,1-3.78.49c-18-4.22-11.95-63-11.95-63,1,.47,2.09,8,6.24,17.6C907.11,644,915.11,667.66,909.32,671.92Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M949.34,637s1.17,31.63-29.05,35.38l-1.87-3.51S947.47,646.87,949.34,637Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M940.68,621.1c.22,34-24.14,49.2-24.14,49.2l-.7-.15-7-1.49c1.39-10.43,9.86-23.56,17.28-33.39A76,76,0,0,1,940.68,621.1Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M915.73,668.84a11.18,11.18,0,0,1-4,3.08h0a7.69,7.69,0,0,1-1.47.49c-4.44,1-6-2.16-5.74-7.6.42-9.69,6.51-26.49,12-39,3.94-9.06,10.37-15.92,11.33-16.37C927.79,609.39,927.52,655.18,915.73,668.84Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M910.69,588.77s-20.15,71.46-2.81,82.24S915.14,595.1,910.69,588.77Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M872,637s-4,31.63,26.24,35.38l1.87-3.51S873.9,646.87,872,637Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M909.75,668.66l-7,1.49-.71.15s-21.56-15.22-21.32-49.2c0,0,5.52,5.92,11.76,14.17C899.9,645.1,908.35,658.23,909.75,668.66Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M909.75,668.66l-7,1.49c-6.67-5.85-9.31-21.12-10.27-34.88C899.9,645.1,908.35,658.23,909.75,668.66Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M912.13,671.92a4.43,4.43,0,0,1-3.78.49c-18.05-4.22-14.76-63-14.76-63,1,.47,4.9,8,9,17.6C909.92,644,917.92,667.66,912.13,671.92Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M949.34,637s4,31.63-26.24,35.38l-1.87-3.51S947.47,646.87,949.34,637Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M940.68,621.1c.22,34-21.33,49.2-21.33,49.2l-.7-.15-7-1.49c1.4-10.43,9.86-23.56,17.28-33.39C935.15,627,940.68,621.1,940.68,621.1Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M928.9,635.27c-.9,12.84-3.25,27-8.95,33.57a11.5,11.5,0,0,1-1.3,1.31l-7-1.49C913,658.23,921.48,645.1,928.9,635.27Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M918.54,668.84a11.18,11.18,0,0,1-4,3.08h0a7.78,7.78,0,0,1-1.48.49c-4.44,1-6-2.16-5.74-7.6.43-9.69,6.51-26.49,12-39,3.94-9.06,7.56-15.92,8.52-16.37C927.79,609.39,930.33,655.18,918.54,668.84Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M912.13,671.92a5,5,0,0,1-2.85-.91c-8.49-5.29-8.66-25.14-6.64-44C909.92,644,917.92,667.66,912.13,671.92Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M918.54,668.84c-1,2.11-2.29,3.23-4,3.08h0a5.74,5.74,0,0,1-2.42-.91,12.88,12.88,0,0,1-4.8-6.2c.43-9.69,6.51-26.49,12-39C921.22,643.2,921.87,661.69,918.54,668.84Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M910.69,588.77s-17.34,71.46,0,82.24S915.14,595.1,910.69,588.77Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "898.85 591.66 826.69 591.66 826.69 603.61 837.7 603.61 837.97 605.02 842.38 628.21 884.33 628.21 888.74 605.02 889.01 603.61 898.85 603.61 898.85 591.66",
    fill: "#ddd"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "898.82 591.66 826.66 591.66 826.66 603.61 837.67 603.61 837.94 605.02 842.35 628.21 884.3 628.21 888.71 605.02 888.98 603.61 898.82 603.61 898.82 591.66",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "892.76 598.69 891.55 605.02 887.14 628.21 845.19 628.21 840.78 605.02 839.57 598.69 892.76 598.69",
    fill: "#ddd"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "892.76 598.69 891.55 605.02 840.78 605.02 839.57 598.69 892.76 598.69",
    opacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 829.5,
    y: 591.66,
    width: 72.16,
    height: 11.95,
    fill: "#ddd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M330.73,591a18.45,18.45,0,0,0-2.44,4.6c-.15.4-.3.86-.45,1.3a3.55,3.55,0,0,0-.85-.29,11.81,11.81,0,0,0-3.82-.33c0-.5.05-1,.07-1.57.16-5.66-.51-13.53-5.9-10.2-5.17,3.22-1.48,8.56,1.86,12,.29.3.57.57.85.84-3,2.19-3.62,7.22-4.13,12.49s-5,11-7.94,14.3c-.29.33-.57.63-.84.91a10.78,10.78,0,0,0-8.62-2.22l-.4-1.46c-2.4-8.67-7.39-23.69-13.75-27l.84-1.06c2.7-3.54,5.74-8.79,1.25-10.13s-4.9,4.55-4.65,9c0,.55.08,1.08.13,1.57a6.63,6.63,0,0,0-4.71,2.29c-.21-.26-.44-.53-.69-.82-3.64-4.31-10.33-11.12-12.35-6-1.88,4.8,4,11,8.14,14.66l.26.22c-2.78,11.28,9.34,20.46,15.88,24.48.29.19.57.36.84.52-9,10.61-14.57,30.51-14.57,30.51L300,664.2s16.73-14.43,14.59-28l.17,0c16.71-3.35,20.51-21.17,17.91-31.75l.29-.12a19,19,0,0,0,7.74-5.85C345.34,592,335.53,584.65,330.73,591Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M330.73,591a18.45,18.45,0,0,0-2.44,4.6c-.15.4-.3.86-.45,1.3a3.55,3.55,0,0,0-.85-.29,11.81,11.81,0,0,0-3.82-.33c0-.5.05-1,.07-1.57.16-5.66-.51-13.53-5.9-10.2-5.17,3.22-1.48,8.56,1.86,12,.29.3.57.57.85.84-3,2.19-3.62,7.22-4.13,12.49s-5,11-7.94,14.3c-.29.33-.57.63-.84.91a10.78,10.78,0,0,0-8.62-2.22l-.4-1.46c-2.4-8.67-7.39-23.69-13.75-27l.84-1.06c2.7-3.54,5.74-8.79,1.25-10.13s-4.9,4.55-4.65,9c0,.55.08,1.08.13,1.57a6.63,6.63,0,0,0-4.71,2.29c-.21-.26-.44-.53-.69-.82-3.64-4.31-10.33-11.12-12.35-6-1.88,4.8,4,11,8.14,14.66l.26.22c-2.78,11.28,9.34,20.46,15.88,24.48.29.19.57.36.84.52-9,10.61-14.57,30.51-14.57,30.51L300,664.2s16.73-14.43,14.59-28l.17,0c16.71-3.35,20.51-21.17,17.91-31.75l.29-.12a19,19,0,0,0,7.74-5.85C345.34,592,335.53,584.65,330.73,591Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M280.53,598.3l-2.95,8.64s-1.64-1.16-3.71-3c-4.14-3.62-10-9.86-8.14-14.66,2-5.16,8.71,1.65,12.36,6C279.55,597,280.53,598.3,280.53,598.3Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M286.75,593.38a42.7,42.7,0,0,1-2.87,3.38,44.25,44.25,0,0,1-.53-4.54c-.24-4.42.22-10.29,4.65-9S289.45,589.84,286.75,593.38Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M324.79,594.74c-.1,2.84-.37,5.11-.37,5.11a37.54,37.54,0,0,1-3.68-3.29c-3.34-3.46-7-8.8-1.85-12C324.28,581.21,324.94,589.08,324.79,594.74Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M342.21,598.46a19,19,0,0,1-7.74,5.85,20.9,20.9,0,0,1-2.6.94l-3.47-4.88a35,35,0,0,1,1.44-4.74,18.13,18.13,0,0,1,2.44-4.6C337.08,584.65,346.88,592,342.21,598.46Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M278.09,595.26c1.46,1.72,2.44,3,2.44,3l-2.95,8.64s-1.64-1.16-3.71-3a16.92,16.92,0,0,1,3.32-7.59Q277.64,595.77,278.09,595.26Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M286.75,593.38a42.7,42.7,0,0,1-2.87,3.38,44.25,44.25,0,0,1-.53-4.54A5.86,5.86,0,0,1,286.75,593.38Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M301.25,627.64l-7.33,3.23a43.9,43.9,0,0,1-3.91-2.21c-7.71-4.74-23.21-16.67-12.82-30.74s19.06,11.16,22.47,23.5C300.7,625.11,301.25,627.64,301.25,627.64Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M320.74,596.56a6,6,0,0,1,4.05-1.82c-.1,2.84-.37,5.11-.37,5.11A37.54,37.54,0,0,1,320.74,596.56Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M334.47,604.31a20.9,20.9,0,0,1-2.6.94l-3.47-4.88a35,35,0,0,1,1.44-4.74C332.08,596.94,333.73,600.2,334.47,604.31Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M316.26,636.18c-.4.08-.82.16-1.23.22-24.59,3.74-8.11-9.53-8.11-9.53s1.11-1,2.61-2.68c3-3.28,7.43-9,7.94-14.3.77-8,1.66-15.45,11.07-13.25C337.77,598.8,339.53,631.52,316.26,636.18Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 223.72,
    y: 621.57,
    width: 46.98,
    height: 12.35,
    fill: "#ddd"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 581.42,
    width: 61.38,
    height: 43.11,
    fill: "#ddd"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 223.72,
    y: 621.57,
    width: 46.98,
    height: 12.35,
    opacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 581.42,
    width: 61.38,
    height: 43.11,
    opacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 621.57,
    width: 46.98,
    height: 12.35,
    fill: "#ddd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M299.66,621.42c1,3.69,1.59,6.22,1.59,6.22l-7.33,3.23a43.9,43.9,0,0,1-3.91-2.21C292.88,625,296.12,622.27,299.66,621.42Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.26,636.18c-.4.08-.82.16-1.23.22-24.59,3.74-8.11-9.53-8.11-9.53s1.11-1,2.61-2.68C314.12,627.86,316,632,316.26,636.18Z",
    transform: "translate(-45.11 -75.83)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M276.29,659.69s13.77-49.28,33.07-34.1-7.85,38.61-7.85,38.61Z",
    transform: "translate(-45.11 -75.83)",
    fill: "#bbb"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 529.82,
    r: 1.54,
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 537.02,
    r: 1.54,
    opacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.78,
    cy: 531.23,
    r: 1.54,
    opacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.75,
    cy: 568.16,
    r: 1.54,
    opacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.57,
    cy: 543.2,
    r: 1.54,
    opacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.61,
    cy: 559.16,
    r: 1.54,
    opacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.41,
    cy: 532.9,
    r: 1.54,
    opacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.54,
    cy: 535.86,
    r: 1.54,
    opacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.26,
    cy: 547.83,
    r: 1.54,
    opacity: 0.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.05,
    cy: 567.01,
    r: 1.54,
    opacity: 0.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.7,
    cy: 559.41,
    r: 1.54,
    opacity: 0.1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.72,
    cy: 542.3,
    r: 1.54,
    opacity: 0.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 621.57,
    width: 46.98,
    height: 4.51,
    opacity: 0.1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 219.34,
    y: 581.42,
    width: 61.38,
    height: 43.11,
    fill: "#ddd"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.11,
    cy: 573.96,
    r: 1.54,
    opacity: 0.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.84,
    cy: 575.89,
    r: 1.54,
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.8c9b945b09a0ec642f1d1b02f78ee3cf.svg";
export { ForwardRef as ReactComponent };